import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl='https://customsprem.gov.tc/';
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [theadrow, setTheadrow] = useState({htm:""});
const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [tblusergrpprivil, setTblusergrpprivil] = useState([]);
const [combolocation, setCombolocation] = useState([]);
const [usergrpoptions, setUsergrpoptions] = useState([]);
const [ugprivil, setUgprivil] = useState([]);


const [wptusername, setWptusername] = useState({});
const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({txt:'', custype:'', userlocation: ''});
const [custype, setCustype] = useState([
<option value='' ></option>
,<option value='Corporate' >Corporate Customers</option>
,<option value='General' >General Customers</option>
]);



const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

if (tblusergrpprivil.length<1){
	gettblusergrpprivil();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	
	console.log("ugprivil.length: "+ugprivil.length);
	if (ugprivil.length>0)
		mkTblusergrpprivil();
	
 },[JSON.stringify(ugprivil)]);



useEffect(() => {
		gettblusergrpprivil();
 },[searchcrit]);

function searchcritChange(e){
	
	const {name, value}=e.target;
console.log("searchcritChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if

async function saveusergrppriv(e){
e.preventDefault();
let LS_USER_PRIVIL_ID="";
for (var i=0; i<ugprivil.length; i++){
	const temp=ugprivil[i];
	console.log("temp: "+JSON.stringify(temp));
	LS_USER_PRIVIL_ID="";
	for (var j=1; j<7; j++){
		if (LS_USER_PRIVIL_ID!="")
			LS_USER_PRIVIL_ID+=",";
		LS_USER_PRIVIL_ID+=temp["P"+j];
		//ID
		}
	await updateusergrpprivil(temp["ID"], LS_USER_PRIVIL_ID);
	}//end for

}//end func

async function updateusergrpprivil(USER_GRP_ID, LS_USER_PRIVIL_ID){

const params={
	USER_GRP_ID:USER_GRP_ID
	,  LS_USER_PRIVIL_ID:LS_USER_PRIVIL_ID
	, USERNAME:""
	
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params)
  };		
setTblusergrpprivil([]);
  await fetch(resturl+'rarwpform/updateusergrpprivil',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersaveusergrppriv(res) )
      .catch(err => console.log(err));

}//end func

function aftersaveusergrppriv(res){
showsnackbar("done!");
}//end func

async function gettblusergrpprivil(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		
setTblusergrpprivil([]);
  await fetch(resturl+'rarwpform/tblusergrpprivil',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblusergrpprivil(res) )
      .catch(err => console.log(err));

}//end func


function mkTblusergrpprivil(){
	console.log("mkTblusergrpprivil");
	let tbodyrows=[];
	//{col['USER_GRP']}
	for (var i=0; i<ugprivil.length; i++){
		const ix=i;
		const trkey="trkey_"+i;
		tbodyrows.push(<tr key={trkey} >
			<td align='right' >{ugprivil[i].UG}</td>
			<td align='center' ><input type="checkbox" checked={ugprivil[i].P1==1?"checked":""} name="P1" onChange={(e)=>{handleChange(ix, e);}} /></td>
			<td align='center' ><input type="checkbox" checked={ugprivil[i].P2==1?"checked":""} name="P2" onChange={(e)=>{handleChange(ix, e);}} /></td>
			<td align='center' ><input type="checkbox" checked={ugprivil[i].P3==1?"checked":""} name="P3" onChange={(e)=>{handleChange(ix, e);}} /></td>
			<td align='center' ><input type="checkbox" checked={ugprivil[i].P4==1?"checked":""} name="P4" onChange={(e)=>{handleChange(ix, e);}} /></td>
			<td align='center' ><input type="checkbox" checked={ugprivil[i].P5==1?"checked":""} name="P5" onChange={(e)=>{handleChange(ix, e);}} /></td>
			<td align='center' ><input type="checkbox" checked={ugprivil[i].P6==1?"checked":""} name="P6" onChange={(e)=>{handleChange(ix, e);}} /></td>
			</tr>);
		}//end for

console.log("tbodyrows.len: "+tbodyrows.length);

	let temp=<table align='center' className='customers' style={{width:"55%", marginTop:"36px"}} >
		{theadrow.htm}
		<tbody>
		{tbodyrows}
		</tbody>
		</table>;
	
	
setTblusergrpprivil(temp);	
}//end func

function handleChange(ix, e){
	const {name, checked}=e.target;
	//window.alert(theadrow);
	//let temp=ugprivil;
	//console.log("name: "+name);
	//console.log("i: "+ix);
	//console.log("temp[i]: "+JSON.stringify(temp[ix]));
	//console.log("temp[i][name]: "+temp[ix][name]);
	
	const valu=checked==true?1:0;
	
	//temp[ix][name]=valu;
	//setUgprivil(temp);
	setUgprivil((prev)=>{
		//return {...prev, temp}
		prev[ix][name]=valu;
		 return [...prev]
	});	
	
/*
	setUgprivil((prev)=>{
		return {...prev, temp}
	});
*/

}//end func


//temp: [{"P1":"0","P2":"0","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"1","P2":"1","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"0","P2":"0","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"0","P2":"1","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"0","P2":"0","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"0","P2":"0","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"0","P2":"0","P3":"0","P4":"0","P5":"0","P6":"0"},{"P1":"0","P2":"0","P3":"0","P4":"0","P5":"0","P6":"0"},

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


function aftergettblusergrpprivil(res){
	
if (res.length==undefined)
	return;
	
console.log('aftergettblusergrpprivil, res.length: '+res.length);

let temp=[];
res.map((col, index) => {
	if (col['BAND']=="A"){
		setTheadrow({htm:<thead>
			<tr key="trkeyA000" >
			<th align='right' >{col['USER_GRP']}</th>
			<th align='center' >{col['P1']}</th>
			<th align='center' >{col['P2']}</th>
			<th align='center' >{col['P3']}</th>
			<th align='center' >{col['P4']}</th>
			<th align='center' >{col['P5']}</th>
			<th align='center' >{col['P6']}</th>
			</tr>
			</thead>});
		//console.log("theadrow: "+JSON.stringify(theadrow));
		}//end if
	else if (col['BAND']=="B")
		temp.push({
			ID: col['USER_PRIVIL_ID']
			, UG: col['USER_GRP']
			, P1: col.P1
			, P2: col.P2
			, P3: col.P3
			, P4: col.P4
			, P5: col.P5
			, P6: col.P6
			})
		});
setUgprivil(temp);

}//end func






const yesnooptions = <>
		<option value="0" >No</option>
		<option value="1" >Yes</option>
		</>;
	
	

  return (
    <>
	
	
	{tblusergrpprivil}

<div align="center" style={{marginTop:"12px"}} ><button onClick={(e)=>{saveusergrppriv(e);}} className="button" >save changes</button></div>

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;